module.exports = __webpack_public_path__ + "static/img/Technological.26944bb6.png";